import { Buffer } from 'buffer';
import { useState } from 'react';



export function getLocalStorageValue(key: string) {
  const value = localStorage.getItem(key);
  if (!value) return null;
  try {
    return JSON.parse(decode(value));
  } catch (error) {
    return null;
  }
}

export function setLocalStorage(key: string, value: string) {
  localStorage.setItem(key, encode(JSON.stringify(value)));
}

export function getSessionStorageValue(key: string) {
  const value = sessionStorage.getItem(key);
  
  if (!value) return null;
  try {
    return JSON.parse(decode(value));
  } catch (error) {
    return null;
  }
}

export function setSessionStorage(key: string, value: any) {
  sessionStorage.setItem(key, encode(JSON.stringify(value)));
}

export const decode = (str: string):string => Buffer.from(str, 'base64').toString('binary');

export const encode = (str: string):string => Buffer.from(str, 'binary').toString('base64');

export const getUrlParam = (paramName: string) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(paramName);
}



export const scroll2Top = () => {
  window.scrollTo({top: 0, behavior: 'smooth'});
}

export const accessJsonAttr = (o: any, s: string) => {
    s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    s = s.replace(/^\./, '');           // strip a leading dot
    var a = s.split('.');
    for (var i = 0, n = a.length; i < n; ++i) {
        var k = a[i];
        if (k in o) {
            o = o[k];
        } else {
            return;
        }
    }
    return o;
}

export function cleanUpSpecialChars(str:string)
{
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

export function useSessionStorage<T>(key: string, initialValue: T) {
  // State to store our value
  // Pass initial state function to useState so logic is only executed once
  const [storedValue, setStoredValue] = useState<T>(() => {
    if (typeof window === "undefined") {
      return initialValue;
    }
    try {
      // Get from local storage by key
      const item = window.sessionStorage.getItem(key);
      if(item) {
        if(initialValue instanceof Map) {
          return new Map(JSON.parse(item));
        } else {
          return JSON.parse(item)
        }
      } else {
        return initialValue;
      }
      // Parse stored json or if none return initialValue

    } catch (error) {
      // If error also return initialValue
      console.log(error);
      return initialValue;
    }
  });
  // Return a wrapped version of useState's setter function that ...
  // ... persists the new value to localStorage.
  const setValue = (value: T | ((val: T) => T)) => {
    try {
      // Allow value to be a function so we have same API as useState
      const valueToStore =
        value instanceof Function ? value(storedValue) : value;
      // Save state
      setStoredValue(valueToStore);
      // Save to local storage
      if (typeof window !== "undefined") {
        window.sessionStorage.setItem(key, JSON.stringify(valueToStore instanceof Map ? Array.from(valueToStore.entries()): valueToStore));
      }
    } catch (error) {
      // A more advanced implementation would handle the error case
      console.log(error);
    }
  };
  return [storedValue, setValue] as const;
}


export function equalArrayString(array1: string[], array2: string[]) {
  return array1.length === array2.length && array1.every((value, index) => value === array2[index]);
}